module.exports = __webpack_public_path__ + "assets/img/soft8.24975852.jpg";